import { render } from "./user-panel.vue?vue&type=template&id=10cfc8d8"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"

import "./user-panel.vue?vue&type=style&index=0&id=10cfc8d8&lang=scss"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__